import {
  buildGameToolVersionRequest,
  createGameToolVersionApi,
  type TafFetch,
} from "@huyafed/gametool-service-api";

export { buildGameToolVersionRequest };

export const GAME_TOOL_VERSION_TAF = {
  moduleName: "webLiveUI",
  funcName: "getGameToolVersion",
} as const;

export async function getGameToolVersion(toolId: string, version?: string) {
  const [{ default: tafFetch }, { gameToolServiceBindings }] = await Promise.all([
    import("./_tafFetch"),
    import("@huyafed/gametool-service-api/jce"),
  ]);

  return createGameToolVersionApi(
    tafFetch as unknown as TafFetch,
    gameToolServiceBindings,
  ).getGameToolVersion(toolId, version);
}
